<template lang="pug">
.odds-box(@click="placeBet($event.target)" :class="cssClass")
  span.odds-label
    span.mr-1(v-if="!!label") {{$t('m.'+label)}}
    template(v-if="['ov','ud'].includes(oddsKey) && !!odds") 
      template(v-if="!!odds['ob']") {{ ballDisplay(odds['ob'], 0, 0, 'OU', '') }} 
    template(v-else)
      template(v-if="['hh','ha'].includes(oddsKey) && !!odds") 
        template(v-if="!!odds['hb']") {{ ballDisplay(odds['hb'], odds['ht'], homeAway, 'HDP', '') }}

  span.odd-value(v-if="!!value" :class="{negative: value < 0}") {{value}}
  span.lock(v-else)
    i.fad.fa-lock-alt
</template>
<script>
import { EventBus } from "@/library/_event-bus.js";

export default {
  props: {
    label: { type: String, default: "" },
    details: { type: Array, required: true },
    source: { type: [Object, Array] },
    typ: { type: String, default: "" },
    oddsKey: { type: String, required: true },
    oddsKeyInd: { type: Number, required: true },
    cls: { type: String, default: "" },
    dataType: { type: String, required: true },
    mode: { type: String, default: "" },
    homeAway: { type: String, default: "" }
  },
  data() {
    return {
      defStake: "",
      value: null,
      trigger: false,
      old: null,
      dir: null,
      odds: null
    };
  },
  computed: {
    betState() {
      return this.$store.state.layout;
    },
    betType() {
      return this.betState.menu3;
    },
    time_machine() {
      return this.$store.getters.timeMachine || {};
    },
    oddsMode() {
      switch (this.oddsKey) {
        case "hh":
        case "ha":
          return "hdp";
        case "ov":
        case "ud":
          return "ou";
        default:
          return false;
      }
    },
    allowBet() {
      if (!this.odds) return false;
      const map = { "1": "hh", "2": "ha", "3": "ov", "4": "ud" };
      const key = map[this.dataType];
      return key ? !!this.odds[key] : false;
    },
    cssClass() {
      if (this.dir !== null) {
        return { [this.dir]: this.value, disabled: !this.value };
      }
    }
  },
  watch: {
    details(newVal, oldVal) {
      this.reset();

      this.odds = this.getOddsByMinute(newVal, this.oddsKeyInd);
      if (!this.odds) return;
      this.value = this.odds[this.oddsKey];
    },
    oddsKeyInd(newVal, oldVal) {
      this.reset();
      if (!this.betState.showTM) return;

      this.odds = this.getOddsByMinute(this.details, newVal);
      if (!this.odds) return;
      this.value = this.odds[this.oddsKey];
    },
    typ(newVal, oldVal) {
      this.reset();
    },
    betType(newVal, oldVal) {
      this.reset();
    },
    value(newVal, oldVal) {
      if (newVal == "" || newVal == 0 || oldVal == null) {
        this.trigger = false;
        this.dir = null;
        return;
      } else {
        if (oldVal === newVal) return;

        this.trigger = true;
        const dropping = newVal < 0 ? oldVal < newVal : oldVal > newVal;
        this.dir = dropping ? "odd-drop" : "odd-rise";

        setTimeout(() => {
          this.trigger = false;
          this.dir = null;
        }, 10000);
      }
    }
  },
  methods: {
    reset() {
      this.trigger = false;
      this.old = null;
      this.dir = null;
    },
    _splitAvg(v) {
      if (!v.includes("-")) return parseFloat(v);
      const [a, b] = v.split("-");
      return (parseFloat(a) + parseFloat(b)) / 2;
    },

    ballDisplay(v, g, b, bt, t) {
      if (v == null || v == "") {
        return null;
      }

      var result = v;

      switch (bt) {
        case "HDP":
        case "HDPH":
          result = this._splitAvg(v);
          // console.log("ballDisplay: ", v, g, b, bt, t, result);
          if (result != 0) {
            const minusPrefix =
              (g === "H" && b == 1) || (g === "A" && b == 2);
            result = `${minusPrefix ? "-" : "+"}${result}`;
          }
          break;
        case "OU":
        case "OUH":
          result = this._splitAvg(v);
          break;
        case "1X2HDP":
        case "1X2HDPH":
          result = this.ballDisplay3way(b, result, t);
          break;
        default:
          return null;
      }

      return result;
    },
    placeBet(e) {
      if (!this.value || !this.allowBet) return;

      this.defStake = this.betState.betting.defaultStake === "0" ? this.betState.betting.defaultStakeAmount : 5;

      if (this.betType != "parlay") {
        if (EventBus.cancelBetTimeMachineDatetime) {
          EventBus.cancelBetTimeMachineDatetime(false);
        }
        if (!!EventBus.betSingle) {
          EventBus.betSingle(this.source.details[this.oddsMode][0], this.typ, this.oddsKeyInd, this.value, this.betType, this.defStake, this.mixParlay, null, e, true);
        }
      } else {
        if (this.mixParlay && EventBus.betParlay) {
          EventBus.betParlay(this.odds, this.typ, this.idx, this.value, this.betType, this.defStake);
        }
      }
    },
    getOddsByMinute(data, min) {
      // Find the object which has the key matching the minute
      const item = data.find(obj => obj.hasOwnProperty(min));
      if (item) return item[min];
      return null; // no odds for this minute
    }
  }
};
</script>
